<template>
  <div class="basicInfoApproval">
    <div class="filters">
      <!-- 添加输入框和选择框、提交按钮 -->
      <el-form :inline="true">
        <!-- 姓名 -->
        <el-form-item>
          <el-input class="seachInput" v-model="name" placeholder="业主姓名"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item>
          <el-input class="seachInput" v-model="mobile" placeholder="业主电话"></el-input>
        </el-form-item>
        <!-- 选择状态 -->
        <el-form-item>
          <el-select class="select" v-model="status" :placeholder="$t('lang.TENANTINFOS.TYPE[0].label')">
            <el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
      <!-- 添加表格 -->
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="tenantInfosListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 原姓名 -->
        <el-table-column prop="oldName" label="原姓名"></el-table-column>
        <!-- 原电话 -->
        <el-table-column prop="oldMobile" label="原电话号"></el-table-column>
        <!-- 原身份证 -->
        <el-table-column prop="oldIdNo" label="原身份证号" width="170px"></el-table-column>
        <!-- 修改后姓名 -->
        <el-table-column prop="newName" label="变更后姓名" >
          <template slot-scope="scope">
            <div :class="scope.row.newName!=scope.row.oldName&&scope.row.state==1?'red':''">{{ scope.row.newName }}</div>
          </template>
        </el-table-column>
        <!-- 修改后电话 -->
        <el-table-column prop="newMobile" label="变更后电话号">
          <template slot-scope="scope">
            <div :class="scope.row.newMobile!=scope.row.oldMobile&&scope.row.state==1?'red':''">{{ scope.row.newMobile }}</div>
          </template>
        </el-table-column>
        <!-- 修改后身份证 -->
        <el-table-column prop="newIdNo" label="变更后身份证号" width="170px">
          <template slot-scope="scope">
            <div v-if="scope.row.newIdNo!=''" :class="scope.row.newIdNo!=scope.row.oldIdNo&&scope.row.state==1?'red':''">{{ scope.row.newIdNo }}</div>
          </template>
        </el-table-column>
        <!-- 修改备注 -->
        <el-table-column prop="remark" label="备注" width="200px"></el-table-column>
        <!-- 附件 -->
        <el-table-column label="附件" prop="photos" width="220px">
          <template slot-scope="scope">
            <viewer :images="scope.row.photos" class="img-width">
              <img v-for="(src,index) in scope.row.photos" :src="src" :key="index" class="img">
            </viewer>
          </template>
        </el-table-column>
        <!-- 申请时间 -->
        <el-table-column sortable :label="$t('lang.lab_applicationTime')" width="150px">
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="openConfirm(scope.row)" v-if="(scope.row.state === '' || scope.row.state === 1)">
              {{$t('lang.btn_cof')}}</el-button>
            <el-button @click="refuse(scope.row)" v-if="(scope.row.state === '' || scope.row.state === 1)">
              {{$t('lang.btn_refuse')}}</el-button>
            <el-button class="green" @click="alConfirm(scope.row)" v-else-if="(scope.row.state === 2)">
              {{$t('lang.btn_alcof')}}</el-button>
            <el-button class="orange" @click="alRefuse(scope.row)" v-else-if="(scope.row.state === 3)">
              {{$t('lang.btn_alRefuse')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :visible.sync="diaIsShow" :close-on-click-modal="false" :title="titleShow" center top="150px"
      width="500px">
      <el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_w1">
        <el-form-item prop="operRemark" class="formname">
          <el-input v-model="form.operRemark" :placeholder="$t('lang.lab_pleInputRefReason')" type="textarea"
          :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="diaConfirm('form')">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:basicInfoApproval
   *@Description:原始业主基本信息审批
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: '/manage/main.tenantInfoManager',
    data() {
      return {
        titleShow: '',
        Id: '',
        flag: '',
        content: '',
        diaIsShow: false, // 弹框是否显示
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        name: '', // 姓名
        mobile: '', // 电话
        status: '', // 状态
        statuss: [{
              value: '',
              label: '请选择状态'
            },
            {
              value: '1',
              label: '审批中'
            },
            {
              value: '2',
              label: '已通过'
            },
            {
              value: '3',
              label: '已拒绝'
            }
          ], // 可选状态
        pageCount: 0, // 总页数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        tenantInfosListcheckbox: require('@/config/enum').tenantInfosListcheckbox, // 是否隐藏复选框  
        form: {
          operRemark: '', // 拒绝原因
        },
        rules: {
          operRemark: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleInputRefReason'),
            trigger: 'blur'
          }],
        }
      }
    },
    // 初始化
    created() {
      this.topics()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号变化
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      }
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 点击查询
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 确认弹窗
      openConfirm(row) {
        this.$confirm('是否通过原始业主信息修改审批?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confirm(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })          
        })
      },
      // 确认
      confirm(row) {
        console.log(row)
        this.Id = row.id
        this.flag = 2
        let loading = this.$loading()
        this.$patch(
          `roomOwnerChangeCheck/${this.Id}?state=${this.flag}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              this.topics()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 拒绝弹窗
      refuse(row) {
        this.titleShow = this.$i18n.t('lang.lab_refReason')
        this.diaIsShow = true
        this.Id = row.id
        this.flag = 3
      },
      // 拒绝取消
      diaCancel() {
        this.form.name = ''
        this.$refs.form.clearValidate()
        this.diaIsShow = false
        this.$message({
          type: 'info',
          message: '已取消'
        })
      },
      // 拒绝确认
      diaConfirm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let loading = this.$loading()
            this.$patch(`roomOwnerChangeCheck/${this.Id}?state=${this.flag}&operRemark=${this.form.operRemark}`
            ).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 列表
      topics() {
        let loading = this.$loading()
        this.$get(
          `roomOwnerChangeCheck?name=${this.name}&mobile=${this.mobile}&state=${this.status}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
          // `getTenantInfoList?tenantName=${this.name}&tenantMobile=${this.mobile}&flag=${this.status}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              this.tableData.forEach((item, index) => {
                console.log(item)
                if (item.photos) {
                  this.$set(item, 'photos', item.photos.split(','))
                } else {
                  this.$set(item, 'photos', [])
                }
              })
              console.log(this.tableData)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.diaCancel()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang='scss'>
  .basicInfoApproval {
    .img {
      width: 80px;
      height: 50px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }

    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }

    .formname {
      text-align: center;
      width: 400px;
    }

    .green {
      color: #008000;
    }
    .red {
      color: red!important;
    }
    ::v-deep(.red){
      color:red;
    }
  }
</style>